module.exports = __webpack_public_path__ + "img/z2.3a75b073.png";